<template>
    <ListadoEvento :event="event">
        <template v-if="event.status == 3">
            <div class="actions d-flex justify-content-center justify-content-lg-end">
                <div class="d-flex align-content-center flex-fill">
                    <button class="button large-button d-flex align-items-center justify-content-center orange-content"
                        disabled>
                        {{ $t('partidos.aplazado') }}
                    </button>
                </div>
            </div>
        </template>
        <template v-else-if="event.entradas_agotadas_online">
            <div class="actions d-flex justify-content-center justify-content-lg-end">
                <div class="d-flex align-content-center flex-fill">
                    <button class="button large-button d-flex align-items-center justify-content-center red-content" disabled>
                        {{ $t('partidos.agotadas') }}
                    </button>
                </div>
            </div>
        </template>
        <template v-else-if="event.fecha_fin_evento <= fecha_actual || event.fecha_fin_sesion <= fecha_actual">
            <div class="actions d-flex justify-content-center justify-content-lg-end">
                <div class="d-flex align-content-center flex-fill">
                    <button class="button large-button d-flex align-items-center justify-content-center orange-content"
                        disabled>
                        {{ $t('partidos.cerrado_definitivo') }}
                    </button>
                </div>
            </div>
        </template>
        <template v-else-if="event.venta_online_cerrada">
            <div class="actions d-flex justify-content-center justify-content-lg-end">
                <div class="d-flex align-content-center flex-fill">
                    <button class="button large-button d-flex align-items-center justify-content-center blue-content mr-2 mr-lg-0"
                        disabled>
                        <div class="row">
                            <div class="col-12">
                                {{ $t('partidos.proximamente') }}
                            </div>
                            <div class="col-12">
                                <Countdown v-if="event.cuenta_atras" :endDate="event.cuenta_atras" @close="recargarEventos"></Countdown>
                            </div>
                        </div>
                    </button>
                    <button class="button large-button d-flex align-items-center justify-content-center green-content"
                        @click="showModal('recordatorio-' + event.id)">
                        {{ $t('partidos.avisame') }}
                    </button>
                </div>
            </div>
            <RecordatorioModal :evento_id="event.id" @close="closeModal" />
        </template>
        <template v-else-if="event.venta_online_cerrada_definitiva">
            <div class="actions d-flex justify-content-center justify-content-lg-end">
                <div class="d-flex align-content-center flex-fill">
                    <button class="button large-button d-flex align-items-center justify-content-center blue-content"
                        disabled>
                        {{ $t('partidos.cerrado_definitivo') }}
                    </button>
                </div>
            </div>
        </template>
        <template
            v-else-if="!event.lfp_id && event.entradas_disponibles.length == 0 && event.entradas_disponibles_abonos.length == 0">
            <div class="actions d-flex justify-content-center justify-content-lg-end">
                <div class="d-flex align-content-center flex-fill">
                    <button class="button large-button d-flex align-items-center justify-content-center blue-content"
                        disabled>
                        {{ $t('partidos.venta_cerrada') }}
                    </button>
                </div>
            </div>
        </template>
        <template v-else>
            <div 
                class="actions d-flex justify-content-center justify-content-lg-end"
                v-if="event.libres > 0 || event.libres_abonados > 0 || event.libres_amigo_abonado > 0 || event.plazas_libres || 'compartido' in event"
            >
                <template class="mr-1" v-if="event.activar_enlace_redireccion">
                    <a 
                        class="button large-button effect-button sitecolor-content d-flex align-items-center justify-content-center"
                        :href="event.enlace_redireccion" target="_blank"
                    >
                        {{ $t('partidos.comprar') }}
                    </a>
                </template>
                <template v-else>
                    <template v-if="!event.lfp_id">
                        <button class="button large-button sitecolor-content d-flex align-items-center justify-content-center red-content disabled w-auto" v-if="!event.libres && event.libres_abonados">
                            {{ $t('partidos.agotadas') }}
                        </button>
                        <GoToCheckoutButton 
                            :title="$t('partidos.comprar')" 
                            :route="event.varias_sesiones ? 'front.eventos.sesiones' : 'front.eventos.show'"
                            v-else-if="!event.solo_abonados && !event.venta_online_cerrada && !event.compartido" 
                            :event_id="event.id"
                            tipo_venta="normal"
                            :sesion_id="event.sesion_id"
                        />
                        <GoToCheckoutButton 
                            :title="$t('partidos.comprar')" 
                            :subtitle="$t('partidos.soy_abonado', {abonado: teatro.texto_abonado})"
                            :route="event.varias_sesiones ? 'front.eventos.sesiones' : 'front.eventos.show.abonados'"
                            v-if="event.tiene_descuento_abonado && !event.venta_online_cerrada && !event.compartido" 
                            :event_id="event.id"
                            tipo_venta="abonados"
                            :sesion_id="event.sesion_id"
                        />
                        <GoToCheckoutButton 
                            :title="$t('partidos.comprar')"
                            :subtitle="$t('partidos.soy_amigo_abonado', {abonado: teatro.texto_abonado})"
                            :route="event.varias_sesiones ? 'front.eventos.sesiones' : 'front.eventos.show.amigosabonados'"
                            v-if="event.amigo_abonado && !event.venta_online_cerrada && !event.compartido" 
                            :event_id="event.id"
                            tipo_venta="amigosabonados"
                            :sesion_id="event.sesion_id"
                        />
                        <a 
                            v-if="event.compartido"
                            class="button large-button effect-button sitecolor-content d-flex align-items-center justify-content-center"
                            :href="event.url_evento" 
                            target="_blank"
                        >
                            {{ $t('partidos.comprar') }}
                        </a>
                    </template>
                    <template v-else>
                        <GoToCheckoutButton 
                            :title="$t('partidos.comprar')" 
                            :route="event.varias_sesiones ? 'front.eventos.sesiones' : 'front.eventos.show'"
                            v-if="!event.venta_online_cerrada"
                            :event_id="event.id"
                            tipo_venta="normal"
                            :sesion_id="event.sesion_id"

                        />
                        <GoToCheckoutButton 
                            :title="$t('partidos.comprar')"
                            :subtitle="$t('partidos.soy_abonado', {abonado: teatro.texto_abonado})"
                            :route="event.varias_sesiones ? 'front.eventos.sesiones' : 'front.eventos.show.abonados'"
                            v-if="event.tiene_descuento_abonado && !event.venta_online_cerrada"
                            :event_id="event.id"
                            tipo_venta="abonados"
                            :sesion_id="event.sesion_id"
                        />
                    </template>
                    
                </template>
            </div>
            <div class="actions d-flex justify-content-center justify-content-lg-end" v-else>
                <GoToCheckoutButton 
                    :title="$t('partidos.comprar')" 
                    :subtitle="$t('partidos.soy_abonado', {abonado: teatro.texto_abonado})"
                    :route="event.varias_sesiones ? 'front.eventos.sesiones' : 'front.eventos.show.abonados'"
                    v-if="event.tiene_descuento_abonado"
                    :event_id="event.id"
                    :sesion_id="event.varias_sesiones ? null : event.sesion_id"
                />
                <div v-else class="d-flex align-content-center flex-fill">
                    <button v-if="event.sesiones_activas" class="button large-button d-flex align-items-center justify-content-center red-content" disabled>
                        {{ $t('eventos.ultimas_entradas') }}
                    </button>
                    <button v-else class="button large-button d-flex align-items-center justify-content-center red-content" disabled>
                        {{ $t('partidos.agotadas') }}
                    </button>
                </div>
            </div>
        </template>
    </ListadoEvento>    
</template>

<script>
import GoToCheckoutButton from "@/components/frontend/events/show/GoToCheckoutButton";
import RecordatorioModal from '@/views/frontend/events/layouts/index/modals/RecordatorioModal.vue';
import Countdown from '../../../common/Countdown';
import ListadoEvento from '@/components/common/ListadoEvento'

export default {
    props: {
        event: {
            required: true,
            type: Object
        }
    },
    methods: {
        showModal(modal) {
            this.$modal.show(modal);
        },
        closeModal(modal) {
            this.$modal.hide(modal);
        },
        recargarEventos() {
            const params = {
                filters : {
                    tid : this.configuracion.hash_teatro
                }
            }

            this.$store.dispatch(this.config.getVuexAlias('front.events.index'), params)
        }
    },
    computed: {
        fecha_actual() {
            const fecha = new Date()
            const fecha_actual = fecha.toISOString().split('T')[0];
            const hora_actual = fecha.toTimeString().split(' ')[0];

            return `${fecha_actual} ${hora_actual}`
        },
        configuracion() {
            return this.$store.getters.getConfig;
        },
        teatro(){
            return this.$store.getters.getTeatro;
        }
    },
    components: {
        GoToCheckoutButton, RecordatorioModal, Countdown, ListadoEvento
    }
}
</script>

<style scoped>
    .info_fecha {
        margin-left: 13px; 
        margin-top: 3px;
    }

    @media (max-width: 768px) {
        .info_fecha {
            margin-left: 0; 
        }
    }
</style>